/**
 * もっと見る機能（スライドアニメーション付き）
 * @param {string} className ボタンのクラス名
 * @param {string} contentDisplay コンテンツの表示方法（デフォルトは'block'）
 * @param {number} duration アニメーションの時間（ミリ秒）
 */
export function showMore(className, contentDisplay = 'block', duration = 100) {
	// もっと見るボタンの取得
	const showMoreButtons = document.querySelectorAll(className);

	// もっと見るボタンが存在しない場合は処理を終了
	if (!showMoreButtons.length) return;

	showMoreButtons.forEach(button => {
		button.addEventListener('click', () => {
			button.style.display = 'none'; // ボタンを非表示

			// もっと見るコンテンツを取得
			let showMoreContent = button.nextElementSibling;
			if (!showMoreContent) return;

			// 一時的に表示して高さを取得
			showMoreContent.style.display = contentDisplay;
			showMoreContent.style.overflow = 'hidden';
			let height = showMoreContent.scrollHeight;

			// 初期状態に戻してアニメーション開始
			showMoreContent.style.height = '0px';

			// アニメーション
			let startTime = performance.now();
			function animateSlideDown(currentTime) {
				let elapsedTime = currentTime - startTime;
				let progress = Math.min(elapsedTime / duration, 1);
				showMoreContent.style.height = `${height * progress}px`;

				if (progress < 1) {
					requestAnimationFrame(animateSlideDown);
				} else {
					// 最後に高さを自動に戻す
					showMoreContent.style.height = '';
					showMoreContent.style.overflow = '';
				}
			}

			requestAnimationFrame(animateSlideDown);
		});
	});
}
